import { render, staticRenderFns } from "./Experts.vue?vue&type=template&id=fb7004b8&scoped=true&"
import script from "./Experts.vue?vue&type=script&lang=js&"
export * from "./Experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7004b8",
  null
  
)

export default component.exports